import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class MachineParamtersService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  
  constructor(private http: HttpClient) { }

  //body => { VG_Id:0
  //            Pu_id:5 }

  gettVariableGroupList(data: any): Observable<any[]> {
    //HistoryVarGroup,EditVarGroup,DeleteVarGroup
    return this.http.post<any[]>(
      this.baseUrl + 'Variable/GetVariableGroupList',
      data
    );
  }

  sumbitGroup(data: any): Observable<any[]> {
    //SaveVarGroup
    return this.http.post<any[]>(this.baseUrl + 'Variable/SumbitGroup', data);
  }

  //body => { VG_Id:0
  //          VA_Id:5 }
  getVariableList(data: any): Observable<any[]> {
    //LoadEditVariable,LoadVariable
    return this.http.post<any[]>(
      this.baseUrl + 'Variable/GetVariableList',
      data
    );
  }
  sumbitVariables(data: any): Observable<any[]> {
    //SaveVariables
    return this.http.post<any[]>(
      this.baseUrl + 'Variable/SumbitVaraibles',
      data
    );
  }
  //body => { VG_Id:0
  //            VA_Id:5
  //            Pu_id:5 }
  getParameterSpecificationsList(data: any): Observable<any[]> {
    //LoadEditParameterSpecifications,LoadParameterSpecifications
    return this.http.post<any[]>(
      this.baseUrl + 'Variable/GetParameterSpecificationsList',
      data
    );
  }

  sumbitParameterSpecifications(data: any): Observable<any[]> {
    //SaveParameterSpecifications
    return this.http.post<any[]>(
      this.baseUrl + 'Variable/SumbitParameterSpecifications',
      data
    );
  }
  deletevariableparameterspec(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'QualityParameter/DeleteVariableParameterSpec', data);
  }
  //body => { Id:0 }
  getDataType(data: any): Observable<any[]> {
    //loadDataType
    return this.http.post<any[]>(this.baseUrl + 'Variable/GetDataType', data);
  }

  //body => { Id:0 }
  getDatasource(data: any): Observable<any[]> {
    //loadDatasoucre
    return this.http.post<any[]>(this.baseUrl + 'Variable/GetDatasource', data);
  }

  //body => { Id:0 }
  getCalculationMethod(data: any): Observable<any[]> {
    //loadCalculationMethod
    return this.http.post<any[]>(
      this.baseUrl + 'Variable/GetCalculationMethod',
      data
    );
  }

  //body => { Id:0 }
  getInputTag(data: any): Observable<any[]> {
    //loadInputTag
    return this.http.post<any[]>(
      this.baseUrl + 'Variable/GetCalculationMethod',
      data
    );
  }

  //body => { Id:0 }
  parameterList(data: any): Observable<any[]> {
    //loadParameterSpecification_Desc
    return this.http.post<any[]>(
      this.baseUrl + 'Variable/ParameterSpecification_Desc',
      data
    );
  }

  //body => { UserId:0 } and response is
  DesktopFunctionsList(data: any): Observable<any[]> {
    //loadInputTag
    return this.http.post<any[]>(this.baseUrl + 'Variable/GetInputTag', data);
  }

  //body => { Id:5 }
  parameterLinkProduct(data: any): Observable<any[]> {
    //loadParameterSpecification_LinkProduct
    return this.http.post<any[]>(
      this.baseUrl + 'Variable/ParameterSpecification_LinkProduct',
      data
    );
  }
  getparameterLinkProduct(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'QualityParam/getparameterlinkproduct', data);
  }
  getGroupData(data: any): Observable<any[]> {
    //loadGroup
    return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  }

  // data type routes

  async GetAllDataTypesDetail(data: any): Promise<any[]> {
    return await this.http
      .post<any[]>(this.baseUrl + 'VariableParameterDataTypeDetail/variablegetalldatatypesdetail', data)
      .toPromise();
  }

  AddDataType(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'VariableParameterDataTypeDetail/AddDataType',
      data
    );
  }

  UpdateDataType(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'VariableParameterDataTypeDetail/UpdateDataType',
      data
    );
  }

  DeleteDataType(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'VariableParameterDataTypeDetail/DeleteDataType',
      data
    );
  }
}
